import { Pricing } from "@/generated/graphql";

export function calculateStartingPrice({ __typename, ...pricing }: Pricing) {
  const values = Object.values(pricing).filter(Boolean);
  return values.length === 0 ? 0 : Math.min(...values);
}
